import { render, staticRenderFns } from "./BenutzerProfilPage.vue?vue&type=template&id=63b7d915&"
import script from "./BenutzerProfilPage.vue?vue&type=script&lang=js&"
export * from "./BenutzerProfilPage.vue?vue&type=script&lang=js&"
import style0 from "./BenutzerProfilPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VIcon,VSnackbar})
